<button #originRef (click)="showPopover()" [class.bg-hover]="dropdownOpen" class="button" mat-icon-button type="button"
        [matBadge]="length"
        [matBadgeHidden]="length===0"
        matBadgeColor="warn"
        [matBadgeOverlap]="true"
>
  <mat-icon color="primary" svgIcon="mat:notifications_active"></mat-icon>
</button>
